import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../lib/axios';

const useProjectStore = create(
  persist(
    (set, get) => ({
      currentProjectId: null,
      projects: [],
      loading: false,
      loaded: false,

      fetchProjects: async () => {
        set({ loading: true });
        try {
          const { data } = await api.get('/projects');
          const projects = data.projects || [];
          set({
            projects,
            loaded: true,
            loading: false,
            currentProjectId: get().currentProjectId
              && projects.some((p) => p.id === get().currentProjectId)
              ? get().currentProjectId
              : data.default_id || projects[0]?.id || null,
          });
        } catch (e) {
          set({ loading: false, loaded: true });
        }
      },

      setCurrentProject: (id) => set({ currentProjectId: id }),

      addProject: (project) =>
        set((state) => ({
          projects: [...state.projects, project],
          // currentProjectId bewusst NICHT ändern — neues Projekt anlegen
          // soll den aktuellen Arbeitskontext nicht wegschnappen.
        })),

      updateProject: (project) =>
        set((state) => ({
          projects: state.projects.map((p) => (p.id === project.id ? { ...p, ...project } : p)),
        })),

      removeProject: (id) =>
        set((state) => {
          const remaining = state.projects.filter((p) => p.id !== id);
          return {
            projects: remaining,
            currentProjectId:
              state.currentProjectId === id
                ? remaining.find((p) => p.is_default)?.id || remaining[0]?.id || null
                : state.currentProjectId,
          };
        }),

      currentProject: () => {
        const { projects, currentProjectId } = get();
        return projects.find((p) => p.id === currentProjectId) || null;
      },
    }),
    {
      name: 'ko-project',
      partialize: (state) => ({ currentProjectId: state.currentProjectId }),
    }
  )
);

export default useProjectStore;
